import React, { useEffect, useState } from "react";
import { fetchTracks, fetchArticles, fetchLiveStreams, fetchCategories, fetchReciters } from "../../lib/api";
import { MusicNotes, FilmReel, Broadcast, Users, Newspaper, FolderSimple } from "@phosphor-icons/react";

function Stat({ label, value, Icon }) {
  return (
    <div className="border-r border-b border-[#2A2A2D] p-8" data-testid={`stat-${label.toLowerCase()}`}>
      <div className="flex items-center justify-between">
        <div className="overline text-[#71717A]">{label}</div>
        <Icon size={20} weight="duotone" className="text-[#B79C7B]" />
      </div>
      <div className="font-serif text-5xl text-ivory mt-4">{value}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState({ audio: 0, video: 0, live: 0, cats: 0, reciters: 0, articles: 0 });

  useEffect(() => {
    Promise.all([
      fetchTracks({ type: "audio", limit: 500 }),
      fetchTracks({ type: "video", limit: 500 }),
      fetchLiveStreams(),
      fetchCategories(),
      fetchReciters(),
      fetchArticles({ limit: 200 }),
    ]).then(([a, v, l, c, r, art]) =>
      setStats({ audio: a.length, video: v.length, live: l.length, cats: c.length, reciters: r.length, articles: art.length })
    );
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="overline text-[#B79C7B]">Overview</div>
      <h1 className="font-serif text-4xl text-ivory mt-2">Welcome back, Editor</h1>
      <p className="text-[#A1A1AA] mt-3 max-w-2xl">A bird's-eye view of the archive. Use the left sidebar to manage streams, content, articles and the people behind them.</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 mt-10 border-t border-l border-[#2A2A2D]">
        <Stat label="Audio Tracks" value={stats.audio} Icon={MusicNotes} />
        <Stat label="Video Tracks" value={stats.video} Icon={FilmReel} />
        <Stat label="Live Streams" value={stats.live} Icon={Broadcast} />
        <Stat label="Categories" value={stats.cats} Icon={FolderSimple} />
        <Stat label="Reciters" value={stats.reciters} Icon={Users} />
        <Stat label="Articles" value={stats.articles} Icon={Newspaper} />
      </div>
    </div>
  );
}
